import { createContext, useContext } from "react";
import type { Location } from "react-router";

/** PC 로그인·가입 모달 뒤에 깔린 화면 안이면 true(AppShell). 화면 진입이 아니므로 조회 이벤트·스낵바·주소 교체를 하지 않는다. */
export const BackdropContext = createContext(false);
export const useIsBackdrop = () => useContext(BackdropContext);

/** 로그인 모달을 여는 navigate 의 state(598:217): 지금 화면을 모달 뒤에 그대로 깐다. */
export const loginModalState = (location: Location) => ({ background: location });
